require("normalize.css/normalize.css");
require("./styles/index.scss");

import Mouse from "./utils/mouse";
import Easing from "./utils/easing";

const canvas = document.querySelector(".main-canvas");
const canvasWidth = (canvas.width =
  window.innerWidth * window.devicePixelRatio);
const canvasHeight = (canvas.height =
  window.innerHeight * window.devicePixelRatio);
const ctx = canvas.getContext("2d");

let size = 100
let angle = 0
let blue = 0
let time = 0
class Triangle {
    constructor(angle, size = 10, blue) {
      this.size = size
      this.angle = angle
      this.blue = blue *255 / 150
      this.red = blue /2
      this.green = blue / 4
      this.increment = 0
      this.colorArray = [this.blue, this.red, this.green]
      this.randomNumber = Math.floor(Math.random() * 3 + 1) 
    }

    update() {
        ctx.rotate(this.angle / 100 / 5 )
        console.log(this.randomNumber)
    }
  
    draw() {
        ctx.save()
        ctx.translate(canvasWidth / 2, canvasHeight / 2);
        ctx.lineWidth = 2;
    
        this.update()
        ctx.beginPath()
        ctx.strokeStyle = `rgb(${this.green}, ${this.red}, ${this.blue})`
        ctx.moveTo( 0, -size)
        ctx.lineTo( 0, -size)
        ctx.lineTo( -size , size )
        ctx.lineTo( size , size )
        ctx.lineTo( 0, -size)
        ctx.lineTo( -size, size )
        ctx.stroke()

        ctx.closePath()
        ctx.restore()
    }
  }


// à chaque image : 60fps
const update = () => {
    requestAnimationFrame(update);

    
//   ctx.fillStyle = "black";
//   ctx.globalAlpha = 0.05;
//   ctx.rect(0, 0, canvasWidth, canvasHeight);
//   ctx.fill();
//   ctx.globalAlpha = 1;

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    for (let i = 1; i < 150; i++) {
        const triangle = new Triangle( angle = time * i,size = 2 * i, blue = i)
        triangle.draw()
    }
    
    time += .1
    
};
requestAnimationFrame(update);
